import request from '@/utils/request'

// 调出计划单
 export function apiOutPlanSheetList (query) {
    return request({
      url: `/scp/scpMpsPlans/outPlanSheet`,
      method: 'get',
      params: query
    })
  }
  // 执行调出计划单
 export function apiOutPlanSheetExecute (query) {
  return request({
    url: `/scp/scpMpsPlans/outPlanSheetExecute`,
    method: 'post',
    data: query
  })
}
// 调入计划单
export function apiInPlanSheetList (query) {
  return request({
    url: `/scp/scpMpsPlans/inPlanSheet`,
    method: 'get',
    params: query
  })
}
// 执行调入计划单
export function apiInPlanSheetExecute (query) {
return request({
  url: `/scp/scpMpsPlans/inPlanSheetExecute`,
  method: 'post',
  data: query
})
}
